const BaseModel = require('./BaseModel');
const HTTPClient = require('../HTTPClient');

class User extends BaseModel {
  static basePath = '/api/v1/users';
  static dataType = 'user';

  constructor(json={}) {
    super(json);

    this.invite = this.invite.bind(this);
    this.permittedTo = this.permittedTo.bind(this);

    this.isValid = this.isValid.bind(this);

    this.parseChildren(['groups', 'visibleContactsFilter']);
  }

  permittedTo(actions) {
    this._permissions ||= (this.permissions || []).reduce((obj, action) => ({...obj, [action]: true}), {});

    if(!Array.isArray(actions)) { actions = [actions] };

    return(actions.every(action => this._permissions[action]));
  }

  invite() {
    const path = `${this.constructor.basePath}/${this.id}/invite`;
    return new HTTPClient().post(path).then(this);
  }

  isValid() {
    this.errors = [];

    if(!this.name || this.name.length < 3) { this.errors.push(['name', 'too short']) }
    if(!this.email || this.email.length < 5 || !this.email.match(/.+@.+\..+/)) { this.errors.push(['email', 'invalid']) }

    if(this.visibleContactsFilter && !this.visibleContactsFilter.isValid()) { this.errors.push(['visibleContactsFilter', 'invalid']) }

    return(this.errors.length == 0);
  }
}

BaseModel.models[User.dataType] = User;
module.exports = User;
